// Color Palette
export const COLORS = {
  // Primary Gradient (Blue/Indigo)
  primary: {
    blue: '#2563EB',
    purple: '#4F46E5',
    gradient: 'linear-gradient(135deg, #2563EB 0%, #4F46E5 100%)',
  },

  // Accent Colors
  accent: {
    cyan: '#06B6D4',
    pink: '#EC4899',
    teal: '#14B8A6',
  },

  // Background Colors
  background: {
    dark: '#0F172A',
    darker: '#020617',
    light: '#F8FAFC',
    white: '#FFFFFF',
    card: '#1E293B',
  },

  // Text Colors
  text: {
    primary: '#0F172A',
    secondary: '#64748B',
    light: '#F1F5F9',
    white: '#FFFFFF',
    muted: '#94A3B8',
  },

  // UI Elements
  ui: {
    border: '#E2E8F0',
    borderDark: '#334155',
    shadow: 'rgba(79, 70, 229, 0.1)',
    hover: '#6366F1',
  },

  // Status Colors
  status: {
    success: '#10B981',
    error: '#EF4444',
    warning: '#F59E0B',
    info: '#3B82F6',
  },
};

// Breakpoints
export const BREAKPOINTS = {
  mobile: '375px',
  tablet: '768px',
  laptop: '1024px',
  desktop: '1440px',
};

// Contact Information
export const CONTACT = {
  whatsapp: {
    number: '+918220343006',
    url: (message = 'Hi! I want to learn more about your AI training programs.') =>
      `https://wa.me/918220343006?text=${encodeURIComponent(message)}`,
  },
  email: 'contact@ruhitechsolutions.com',
  phone: '+91 8220343006',
  address: '#140, 1st Floor, Plaza Center, No 129, G.N. Chettey Road, Chennai - 600006',
};

// Social Media Links (Update with actual links)
export const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/ruhitechsolutions/',
};

// Firebase & API Keys
export const RECAPTCHA_SITE_KEY = '6Lf8-TwqAAAAAIzC__WcL3VnfWR4A2B6PYFS0pve';

// Company Information
export const COMPANY = {
  name: 'RuhiTech Solutions',
  tagline: 'Your AI Readiness Partner',
  description: 'AI Survival Training & Digital Transformation',
  logo: '/logo.png',
};
